// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.67105 1.59007L3.66692 1.58594L2.25269 3.00013L4.39573 5.14323C3.57972 5.59808 2.79318 6.12533 2.0455 6.72498L1.26636 7.34987L12.6671 21.6008L16.3052 17.053L21.6665 22.4144L23.0764 21.0045L3.66675 1.59437L3.67105 1.59007Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.8156 13.9151L24.0678 7.34974L23.2887 6.72485C19.0212 3.30228 13.4881 2.23837 8.43366 3.53293L18.8156 13.9151Z"}}]};

const WifiOff1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'wifi-off-1-filled',
    ref,
    icon: element,
  },
));

WifiOff1FilledIcon.displayName = 'WifiOff1FilledIcon';

export default WifiOff1FilledIcon;
